var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"container"},[_c('app-navigation',{attrs:{"options":_vm.pages},on:{"navigate":function($event){return _vm.navigate($event)}}}),_vm._v(" "),_c(_vm.page,{tag:"component",attrs:{"pageconfig":_vm.pageConfig}}),_vm._v(" "),_c('br'),_c('br')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-011f804c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 170
// module chunks = 0